export const isNullish = (value: unknown): value is null | undefined => {
  return value === null || value === undefined;
};

export const isFalsy = (value: unknown): value is '' | 0 | false | null | undefined => {
  return value === '' || value === 0 || value === false || value === null || value === undefined;
};
